export class PlannerConfig {
  public static EndPoint = {
    ProjectSetup: {
      GetQTO: 'ProjectActivity/ProjectQTO',
      ImportQto: 'DataImport/ImportQTO',
      ImportNorm: 'DataImport/ImportNorm',
      UpdateQTOScopeByPlanner: 'ProjectActivity/UpdateQTOScopeByPlanner',
      FourWeekLookahead: 'DataExport/FourWeekLookahead',
      ClearQto: 'DataImport/ClearQTO',
      ClearNorm: 'DataImport/ClearNorm',
      Getprojects: 'User/projects',
      p6Update: 'DataExport/P6Update',
      DeleteQto : 'DataImport/DeleteQTOItems',
      GetQTOImportLogo : 'DataExport/GetQTOImportLog',
      ImportPrimaveraActivities : 'DataImport/ImportPrimaveraActivities',
      ImportSubActivities : 'DataImport/ImportResourceSubActivities'

    },
    ProjectActivity: {
      GetResourse: 'ProjectActivity/PrimaveraResource',
      GetActivity: 'ProjectActivity/PrimaveraActivity',
      GetResourseQto: 'ProjectActivity/PrimaveraQTOResource',
      UpdateProjectWf : 'DataImport/UpdateProjectWorkfronts'
    },
    ImportLookAhead: {
      // GetImport: 'LookAhead/PlannerLookahead'
      GetImport: 'LookAhead/GetLookaheadByService'
    },
    Lookahead: {
      LookaheadService: 'LookAhead/GetLookaheadByDiscipline',
      GetImport: 'LookaheadServiceActivity/4WLookahead',
      GetProjectEngineers: 'ProjectUser/GetProjectEngineers',
      AssignPublish: 'LookAhead/AssignPublish',
      AssignEngineerSupervisor: 'LookAhead/AssignEngineerSupervisor',
      AssignEngineerByResource: 'LookAhead/AssignEngineerByResource',
      LookaheadSummary: 'LookAhead/GetPlannerLookaheadSummary',
      GetLookaheadReviewProgress: 'LookAhead/GetLookaheadReviewProgress',
      GetPlannerOverallGraphview: 'LookAhead/GetPlannerOverallGraphview',
      GetPlannerDisciplineGraphview: 'LookAhead/GetPlannerDisciplineGraphview',
      GetDisciplineGraph: 'LookAhead/GetPlannerResourceGraphviewByDiscipline',
      GetProgressByResource: 'LookAhead/GetProgressByResource',
      UpdatePlannerActuals: 'LookAhead/UpdatePlannerActuals',
      DiscardReviewProgress: 'LookAhead/discardPlannerReviewProgressActualQuantity',
      CancelReviewProgress: 'LookAhead/cancelPlannerReviewProgressActualQuantity',
      SaveReviewProgress: 'LookAhead/SavePlannerReviewProgress',
      LoadSummaryWeekdetails : 'LookAhead/GetWeekStartAndEndDate'

    },
    Publish: {
      publishList: 'LookaheadServiceActivity/GetPlannerPublish'
    },
    Dashboard: {
      dashboard: 'report/mydashboard',
      Import4WLookahead: 'DataImport/SyncLookahead',
      clearp6: 'DataImport/ClearP6Sync',
      DownloadQto : 'DataExport/engineerqtosheet'
    },
    CloseOpenItems: {
      getCloseOpenItems: 'LookAhead/GetCloseOpenItems',
      GetSupervisor: 'ProjectUser/GetProjectEngineers',
      GetCloseOpenActionItems: 'LookAhead/GetCloseOpenActionItems/CloseOpenItems',
      InsertCloseOpenItem: 'LookAhead/UpdatePlannerCloseOpenItem'
    },
    Unplublish: {
      getUnplublishActivity: 'LookAhead/GetLookaheadUnAssignedActivities'
    },
    Workfront: {
      getWorkFront: 'WorkFront/SearchWorkfrontFilter'
    },
    UpdateP6: {
      ReviewProgress: 'LookAhead/GetLookaheadReviewProgress',
      Updatep6list: 'LookAhead/GetP6ReviewProgressUpdateActivities'
    },
    Reports: {
      GetDiscipline: 'Report/getDiscipline',
      GetRole: 'Report/getRole',
      GetPlannerReports: 'Report/GetPlannerReports',
      GetPlannerRankingReport: 'Report/GetPlannerRankingReportDetails'
    },
    ChangePwd: {
      changepwd: 'Account/ChangePassword'
    }
  };
}
